import React from "react";
import { ShieldCheck } from "lucide-react";
import { useContent } from "../../lib/content";

export const WarrantySection = () => {
  const { warranty: w } = useContent();
  return (
  <section data-testid="home-warranty" className="section-pad bg-white">
    <div className="max-w-[1000px] mx-auto px-5 lg:px-8">
      <div className="rounded-3xl bg-gradient-to-br from-[#0a1f44] to-[#06142e] border-2 border-[#3b9dff]/60 shadow-[0_20px_50px_-12px_rgba(59,157,255,0.35)] p-8 md:p-12 flex flex-col md:flex-row gap-8 tex-grid-dark tex-glow overflow-hidden">
        <span className="w-16 h-16 shrink-0 rounded-2xl bg-[#3b9dff]/15 border border-[#3b9dff]/40 flex items-center justify-center"><ShieldCheck className="w-9 h-9 text-[#7dc4ff]" /></span>
        <div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white">{w.heading}</h2>
          <p className="mt-4 text-slate-300 leading-relaxed">{w.text}</p>
        </div>
      </div>
    </div>
  </section>
  );
};
